import axios from "axios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getScoreCards = async () => {
  const data = await axios.get(`${api_base_url}/ScoreCard`);
  return data;
};

export const getScoreCardList = async (query, pageParams) => {
  let params;
  if (pageParams !== undefined) {
    params = Object.keys(pageParams).reduce((acc, key) => {
      if (pageParams[key]?.length > 0 || pageParams[key] > 0) {
        acc[key] = pageParams[key];
      }
      return acc;
    }, {});
  }
  var queryStrings = new URLSearchParams(params).toString();
  var pageSize = query.pageSize !== undefined ? query.pageSize : 10;
  var pageNumber = query.page !== undefined ? query.page + 1 : 1;
  const url = queryStrings
    ? `${api_base_url}/ScoreCard/ScoreCard?PageNumber=${pageNumber}&PageSize=${pageSize}&${queryStrings}`
    : `${api_base_url}/ScoreCard/ScoreCard?PageNumber=${pageNumber}&PageSize=${pageSize}`;
  return await axios.get(url);
};
export const getScoreCardDownload = async (downloadParams) => {
  let params;
  if (downloadParams !== undefined) {
    params = Object.keys(downloadParams).reduce((acc, key) => {
      if (downloadParams[key]?.length > 0 || downloadParams[key] > 0) {
        acc[key] = downloadParams[key];
      }
      return acc;
    }, {});
  }
  var queryStrings = new URLSearchParams(params).toString();
  const url = queryStrings
    ? `${api_base_url}/ScoreCard/ScoreCardDownload?${queryStrings}`
    : `${api_base_url}/ScoreCard/ScoreCardDownload`;

  const download = await axios.get(url);
  return download;
};
//Insert New Scorecard
export const addScorecard = async (newSC) => {
  return await axios.post(`${api_base_url}/ScoreCard`, {
    ...newSC,
  });
};

//Edit Scorecard
export const updateScorecard = async (editScorecard) => {
  return await axios.put(
    `${api_base_url}/ScoreCard/${editScorecard.caseNumber}`,
    editScorecard
  );
};

export const getScorecardStatus = async () => {
  const data = await axios.get(`${api_base_url}/ScoreCard/ScorecardStatus`);
  return data;
};

export const getScorecardType = async () => {
  const data = await axios.get(`${api_base_url}/ScoreCard/ScorecardType`);
  return data;
};

export const getScorecardArea = async () => {
  const data = await axios.get(`${api_base_url}/ScoreCard/ScorecardArea`);
  return data;
};

export const getDescriptiveGroup = async () => {
  const data = await axios.get(`${api_base_url}/ScoreCard/ScorecardDescGroup`);
  return data;
};

export const getScorecardCloseReason = async () => {
  const data = await axios.get(
    `${api_base_url}/ScoreCard/ScorecardCloseReason`
  );
  return data;
};

export const getScorecardException = async () => {
  const data = await axios.get(`${api_base_url}/ScoreCard/ScorecardException`);
  return data;
};

export const getScorecardGeneralGroup = async () => {
  const data = await axios.get(
    `${api_base_url}/ScoreCard/ScorecardGeneralGroup`
  );
  return data;
};

export const getScorecardDispute = async () => {
  return await axios.get(`${api_base_url}/ScoreCard/ScorecardDispute`);
};

export const getScorecardBy = async (searchDetails) => {
  return await axios.post(
    `${api_base_url}/Scorecard/searchDetails`,
    searchDetails
  );
};

export const searchScorecard = async (searchDetails) => {
  return await axios
    .post(`${api_base_url}/Scorecard/searchDetails`, searchDetails)
    .then((res) => {
      if (res && res.status === 200) {
        return res.data;
      } else {
        return [];
      }
    });
};

export const getScorecardByCaseNumber = async (caseNumber) => {
  let scorecardData;
  await axios
    .get(`${api_base_url}/Scorecard/${caseNumber}`)
    .then((res) => (scorecardData = res.data));
  return scorecardData;
};

export const getScorecardByCaseNumbers = async (scIds) => {
  return await axios
    .post(`${api_base_url}/Scorecard/GetScorecardByCasenumbers`, scIds)
    .then((res) => {
      if (res) {
        return res.data;
      }
    });
};

// Deactivate Scorecard
export const deactivateScoreCard = async (ids) => {
  return await axios.put(`${api_base_url}/Scorecard/DeactivateScoreCard`, ids);
};

export const getActionRequired = async () => {
  const data = await axios.get(`${api_base_url}/Scorecard/ActionRequired`);
  return data;
};
export const GetAllScoreCardCounts = async () => {
  const data = await axios.get(`${api_base_url}/ScoreCard/GetCount`);
  return data;
};
